import type { SlaOverview } from '@rp/contracts'
import { OPERATIONS_COPY } from './copy'
import { SlaList } from './SlaList'

export const SlaPanel = ({ overview }: { overview: SlaOverview }) => (
  <section className="ops-section" aria-labelledby="ops-sla-title">
    <div className="ops-section-head">
      <h2 id="ops-sla-title">{OPERATIONS_COPY.slaTitle}</h2>
      <p className="ops-section-summary">{OPERATIONS_COPY.slaSummary(overview.atRisk, overview.breached)}</p>
    </div>
    {overview.atRisk + overview.breached === 0 ? (
      <p className="ops-empty">{OPERATIONS_COPY.slaEmpty}</p>
    ) : (
      <>
        <SlaList state="at_risk" />
        <SlaList state="breached" />
      </>
    )}
  </section>
)
